__turbopack_context__.v({
  "amount": "FundraiserGiftActivity-module-scss-module__EfiAMa__amount",
  "container": "FundraiserGiftActivity-module-scss-module__EfiAMa__container",
  "donation": "FundraiserGiftActivity-module-scss-module__EfiAMa__donation",
  "message": "FundraiserGiftActivity-module-scss-module__EfiAMa__message",
  "noDonations": "FundraiserGiftActivity-module-scss-module__EfiAMa__noDonations",
  "seemore": "FundraiserGiftActivity-module-scss-module__EfiAMa__seemore",
  "title": "FundraiserGiftActivity-module-scss-module__EfiAMa__title",
});
